import { z } from 'zod';
export const signupRequest = z.object({
    email: z.string().email().max(254),
    /**
     * Long rather than complex. Length is what actually resists offline cracking,
     * and an arbitrary symbol rule mostly produces one predictable password with
     * an exclamation mark on the end.
     */
    password: z.string().min(12).max(200),
    displayName: z.string().min(1).max(80),
    timezone: z.string().max(64).default('UTC'),
});
export const loginRequest = z.object({
    email: z.string().email().max(254),
    password: z.string().min(1).max(200),
});
export const updateProfile = z.object({
    displayName: z.string().min(1).max(80).optional(),
    timezone: z.string().max(64).optional(),
    aiReview: z.enum(['off', 'auto', 'button']).optional(),
    aiLevel: z.enum(['off', 'transcribe', 'summarise', 'reflect', 'converse']).optional(),
    lifeEventReminder: z.boolean().optional(),
    aiWarmth: z.enum(['plain', 'balanced', 'warm']).optional(),
    /** Release 3 of 2.0: when the morning face ends and the night face starts, HH:MM in the owner's zone. */
    morningEndsAt: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/).optional(),
    nightStartsAt: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/).optional(),
    /** Release 4 of 2.0: the door files what he says (default on, needs the summarise rung); his own earlier reads come back (default on). */
    doorFiling: z.boolean().optional(),
    ownWordsBack: z.boolean().optional(),
    /** 14 Oct 2026: with this off the door files its picks as soon as it has read the entry; × then unfiles. Default on. */
    doorAsks: z.boolean().optional(),
    /** Sleep from Health (14 Oct 2026): the switch, off by default, and the two boundaries in hours. */
    sleepFromHealth: z.boolean().optional(),
    shortNightUnder: z.number().min(2).max(12).multipleOf(0.5).optional(),
    longNightOver: z.number().min(2).max(14).multipleOf(0.5).optional(),
    /** The fixes pass (13 Oct 2026): Today shows "Marks · n" until tapped, for a phone that is often face-up. Off by default. */
    hideMarksAtRest: z.boolean().optional(),
    /** Two a day (PRD-2.0 §2): web push at the morning time and the night face, off by default. */
    notifications: z.boolean().optional(),
    morningAt: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/).optional(),
});
export const changePassword = z.object({
    currentPassword: z.string().min(1).max(200),
    newPassword: z.string().min(12).max(200),
});
//# sourceMappingURL=auth.js.map